import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/config.js'; 

function Destinations() {
  const [popularDestinations, setPopularDestinations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/featured-destinations/tour-packages`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        setPopularDestinations(data.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDestinations();
  }, []);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (error) return <div className="text-center py-5 text-danger">Error: {error}</div>;

  return (
    <section className="top-destination-section section-padding fix">
      <div className="container">
        <div className="section-title text-center">
          <span className="sub-title wow fadeInUp">Top Destination</span>
          <h2 className="wow fadeInUp" data-wow-delay=".3s">
            Most Popular Destinations
          </h2>
        </div>
        <div className="new-top-destination-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                {popularDestinations.slice(0, 3).map((destination, index) => (
                  <div key={index} className="col-md-6">
                    <div className="new-top-desti-thumb">
                      <img
                        src={destination.image}
                        alt={destination.name}
                        className="img-fluid"
                      />
                      <a
                        href={destination.image}
                        className="icon img-popup2"
                      >
                        <i className="fa-regular fa-plus"></i>
                      </a>
                      <div className="content">
                        <h4>
                          <a href={`/destination-details/${destination.slug}`}>
                            {destination.name}
                          </a>
                        </h4>
                        <p>{destination.country} - {destination.rating} Rating</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="row">
                {popularDestinations.slice(3, 7).map((destination, index) => (
                  <div key={index + 3} className="col-md-6">
                    <div className="new-top-desti-thumb">
                      <img
                        src={destination.image}
                        alt={destination.name}
                        className="img-fluid"
                      />
                      <a
                        href={destination.image}
                        className="icon img-popup2"
                      >
                        <i className="fa-regular fa-plus"></i>
                      </a>
                      <div className="content">
                        <h4>
                          <a href={`/destination-details/${destination.slug}`}>
                            {destination.name}
                          </a>
                        </h4>
                        <p>{destination.country} - {destination.rating} Rating</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Destinations;